import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-parchment py-20 md:py-28" data-id="element-43" data-mp="1bmd89bfimk76">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 md:px-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-44" data-mp="1gj3pi2323lu6">
        <h2 className="font-serif text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-45" data-mp="248xzmbvzqwaq">Preguntas frecuentes</h2>
        <ul className="divide-y divide-line border-y border-line" data-id="element-46" data-mp="289hwdecnjxwc">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <li key={faq.question} data-id="element-47" data-mp="1zho9792mboxs" data-mpi={i}>
                <h3 data-id="element-48" data-mp="1zgn0hb92rej8">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:text-gold-dark" data-id="element-49" data-mp="1zg4uvo0ivnyn">
                    <span className="font-serif text-2xl font-semibold leading-tight text-ink" data-id="element-50" data-mp="14wbwmtzgoxxa">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-51" data-mp="10v9xse9ginvu" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="19t2dvkn05zka">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-53" data-mp="1oihy0hs136r0">
                      <p className="max-w-2xl pb-6 text-lg leading-relaxed text-muted" data-id="element-54" data-mp="36gl93mcoe0q">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}